import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./scss/index.scss";
import "./scss/index.css";
import Store from "./store";
import { Provider } from "react-redux";
import Home from "./components/Home";
import Login from "./components/Auth/Login";
import AuthRoutes from "./protectedRoutes/AuthRoutes";
import PrivateRoutes from "./protectedRoutes/PrivateRoutes";
import RootLayout from "./layouts/RootLayout";
import DashboardMain from "./pages/Dashboard/DashboardMain";
import CategoriesMain from "./pages/Categories/CategoriesMain";
import AddCategories from "./pages/Categories/AddCategories";
import EditCategories from "./pages/Categories/EditCategories";
import AddSubCategories from "./pages/SubCategories/AddSubCategories";
import SubCategoriesMain from "./pages/SubCategories/SubCategoriesMain";
import EditSubCategories from "./pages/SubCategories/EditSubCategories";
import ProductMain from "./pages/Products/ProductMain";
import AddProduct from "./pages/Products/AddProduct";
import ManageUserMain from "./pages/ManageUser/ManageUserMain";
import AddUser from "./pages/ManageUser/AddUser";
import SetNewPassword from "./components/Auth/SetNewPassword";
import OrdersMain from "./pages/Orders/OrdersMain";
import ReportsMain from "./pages/Reports/ReportsMain";
import StockAdjustmentMain from "./pages/StockAdjustment/StockAdjustmentMain";
import CurrencyMain from "./pages/Currency/CurrencyMain";
import AddCurrency from "./pages/Currency/AddCurrency";
import AddOrder from "./pages/Orders/AddOrder";
import PurchaseMain from "./pages/Purchases/PurchaseMain";
import AddPurchase from "./pages/Purchases/AddPurchase";
import VendorMain from "./pages/Vendor/VendorMain";
import AddVendor from "./pages/Vendor/AddVendor";
import CustomersMain from "./pages/Customers/CustomersMain";
import AddCustomers from "./pages/Customers/AddCustomers";
import ContactMessages from "./pages/Customers/ContactMessages";
import FAQsMain from "./pages/FAQs/FAQsMain";
import AddFAQs from "./pages/FAQs/AddFAQs";
import EditFAQs from "./pages/FAQs/EditFAQs";
import TermsMain from "./pages/Terms/TermsMain";
import AddTerms from "./pages/Terms/AddTerms";
import EditTerms from "./pages/Terms/EditTerms";
import PoliciesMain from "./pages/Policies/PoliciesMain";
import AddPolicies from "./pages/Policies/AddPolicies";
import EditPolicies from "./pages/Policies/EditPolicies";
import SetupMain from "./pages/Setup/SetupMain";
import SetupLayout from "./pages/Setup/SetupLayout";
import AppBranding from "./components/AppBranding";
import SystemRoutes from "./protectedRoutes/SystemRoutes";
import ManageCoupons from "./pages/Setup/HeroSection/ManageCoupons";
import ManageHeroSection from "./pages/Setup/HeroSection";
import ManageContactSection from "./pages/Setup/ContactSection";
import OrderNumberSettings from "./pages/Setup/OrderNumberSettings";
import Themes from "./pages/Setup/Themes";
import MenuBuilder from "./pages/Setup/MenuBuilder";
import LayoutSetup from "./pages/Setup/LayoutSetup";
import PageLayoutManagement from "./pages/Setup/PageLayoutManagement";
import WidgetSetup from "./pages/Setup/WidgetSetup";
import BrandLogos from "./pages/Setup/BrandLogos";
import RolesMain from "./pages/Roles/RolesMain";
import RoleForm from "./pages/Roles/RoleForm";
import { PermissionProvider } from "./permissions/PermissionContext";
import APIDocs from "./pages/APIDocs";
import LiveChatPage from "./pages/LiveChatPage";
import CustomerOrderReviews from './pages/Reviews/CustomerOrderReviews';
import CustomerQuestion from './pages/Reviews/CustomerQuestion';
import ReviewAnalysisCenter from './pages/Reviews/ReviewAnalysisCenter';
import ManageReviewsMain from './pages/ManageReviews/ManageReviewsMain';
import AddReview from './pages/ManageReviews/AddReview';
import EditReview from './pages/ManageReviews/EditReview';
import ViewReview from './pages/ManageReviews/ViewReview';
import ProductSelectionMain from './pages/ProductSelection/ProductSelectionMain';
import WarehousesMain from './pages/Warehouses/WarehousesMain';
import CouponsMain from './pages/Coupons/CouponsMain';
import AddCoupon from './pages/Coupons/AddCoupon';
import PluginsMain from './pages/Plugins/PluginsMain';
import MetaAdsPlugin from './pages/Plugins/MetaAdsPlugin';
import GoogleReviewsPlugin from './pages/Plugins/GoogleReviewsPlugin';
import GreenApiPlugin from './pages/Plugins/GreenApiPlugin';
import EmailPlugin from './pages/Plugins/EmailPlugin';
import GA4Plugin from './pages/Plugins/GA4Plugin';
import GSCPlugin from './pages/Plugins/GSCPlugin';
import ClaudePlugin from './pages/Plugins/ClaudePlugin';
import AIAssistant from './pages/AIAssistant';
function App() {
  return (
    <Provider store={Store}>
      <AppBranding>
        <PermissionProvider>
        <Router>
          <Routes>
            <Route
              element={
                <RootLayout>
                  <PrivateRoutes />
                </RootLayout>
              }
            >
              <Route path="/dashboard" exact element={<DashboardMain />} />
              <Route path="/live-chat" exact element={<LiveChatPage />} />
              <Route path="/categories" exact element={<CategoriesMain />} />
              <Route path="/faqs" exact element={<FAQsMain />} />
              <Route path="/add-faqs" exact element={<AddFAQs />} />
              <Route path="/edit-faqs/:id" exact element={<EditFAQs />} />
              <Route path="/terms" exact element={<TermsMain />} />
              <Route path="/add-terms" exact element={<AddTerms />} />
              <Route path="/edit-terms/:id" exact element={<EditTerms />} />

              <Route path="/policies" exact element={<PoliciesMain />} />
              <Route path="/add-policies" exact element={<AddPolicies />} />
              <Route
                path="/edit-policies/:id"
                exact
                element={<EditPolicies />}
              />
               <Route
                path="/hero-section"
                exact
                element={<ManageHeroSection />}
              />

              <Route path="/add-categories" exact element={<AddCategories />} />
              <Route
                path="/sub-categories"
                exact
                element={<SubCategoriesMain />}
              />
              <Route
                path="/add-sub-categories"
                exact
                element={<AddSubCategories />}
              />
              <Route
                path="/edit-categories/:id"
                exact
                element={<EditCategories />}
              />
              <Route
                path="/edit-sub-categories/:id"
                exact
                element={<EditSubCategories />}
              />
              <Route path="/products" exact element={<ProductMain />} />
              <Route path="/add-product" exact element={<AddProduct />} />
              <Route
                path="/edit-product/:productId"
                exact
                element={<AddProduct />}
              />
              <Route path="/product-selection" exact element={<ProductSelectionMain />} />
              <Route path="/manage-users" exact element={<ManageUserMain />} />
              <Route path="/add-user" exact element={<AddUser />} />
              <Route path="/edit-user/:userId" exact element={<AddUser />} />
              <Route path="/roles" exact element={<RolesMain />} />
              <Route path="/add-role" exact element={<RoleForm />} />
              <Route path="/edit-role/:roleId" exact element={<RoleForm />} />

              <Route path="/orders" exact element={<OrdersMain />} />
              <Route path="/add-order" exact element={<AddOrder />} />
              <Route path="/edit-order/:orderId" exact element={<AddOrder />} />
              
              <Route path="/reports" exact element={<ReportsMain />} />
              <Route path="/stock-adjustments" exact element={<StockAdjustmentMain />} />

              <Route path="/warehouses" exact element={<WarehousesMain />} />

              <Route path="/manage-coupons" exact element={<CouponsMain />} />
              <Route path="/add-coupon" exact element={<AddCoupon />} />
              <Route path="/edit-coupon/:couponId" exact element={<AddCoupon />} />

              <Route path="/manage-currency" exact element={<CurrencyMain />} />
              <Route path="/add-currency" exact element={<AddCurrency />} />
              <Route
                path="/edit-currency/:currencyId"
                exact
                element={<AddCurrency />}
              />

              <Route
                path="/manage-customers"
                exact
                element={<CustomersMain />}
              />
              <Route path="/add-customers" exact element={<AddCustomers />} />
              <Route path="/contact-submissions" exact element={<ContactMessages />} />
              <Route
                path="/edit-customer/:customerId"
                exact
                element={<AddCustomers />}
              />

              <Route path="/manage-vendor" exact element={<VendorMain />} />
              <Route path="/add-vendor" exact element={<AddVendor />} />
              <Route
                path="/edit-vendor/:vendorId"
                exact
                element={<AddVendor />}
              />

              <Route path="/purchase" exact element={<PurchaseMain />} />
              <Route path="/add-purchase" exact element={<AddPurchase />} />
              <Route
                path="/edit-purchase/:purchaseId"
                exact
                element={<AddPurchase />}
              />

              <Route path="/customer-order-reviews" exact element={<CustomerOrderReviews />} />
              <Route path="/customer-questions" exact element={<CustomerQuestion />} />
              <Route path="/review-analysis-center" exact element={<ReviewAnalysisCenter />} />
              
              <Route path="/manage-reviews" exact element={<ManageReviewsMain />} />
              <Route path="/add-review" exact element={<AddReview />} />
              <Route path="/edit-review/:reviewId" exact element={<EditReview />} />
              <Route path="/view-review/:reviewId" exact element={<ViewReview />} />

              <Route path="/plugins" exact element={<PluginsMain />} />
              <Route path="/plugins/meta-ads" exact element={<MetaAdsPlugin />} />
              <Route path="/plugins/google-reviews" exact element={<GoogleReviewsPlugin />} />
              <Route path="/plugins/green-api" exact element={<GreenApiPlugin />} />
              <Route path="/plugins/email" exact element={<EmailPlugin />} />
              <Route path="/plugins/ga4" exact element={<GA4Plugin />} />
              <Route path="/plugins/gsc" exact element={<GSCPlugin />} />
              <Route path="/plugins/claude" exact element={<ClaudePlugin />} />
              <Route path="/ai-assistant" exact element={<AIAssistant />} />
            </Route>

            <Route path="/" element={<AuthRoutes />}>
              <Route index element={<Login />} />
            </Route>

            <Route
              path="/users/:id/set-new-password/:token"
              element={<SetNewPassword />}
            />
            <Route
              element={
                <RootLayout>
                  <SystemRoutes />
                </RootLayout>
              }
            >
              <Route
                path="/site-setup"
                exact
                element={
                  <SetupLayout>
                    <SetupMain />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/coupons"
                exact
                element={
                  <SetupLayout>
                    <ManageCoupons />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/hero-section"
                exact
                element={
                  <SetupLayout>
                    <ManageHeroSection />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/contact-section"
                exact
                element={
                  <SetupLayout>
                    <ManageContactSection />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/order-number-settings"
                exact
                element={
                  <SetupLayout>
                    <OrderNumberSettings />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/themes"
                exact
                element={
                  <SetupLayout>
                    <Themes />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/menu"
                exact
                element={
                  <SetupLayout>
                    <MenuBuilder />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/layout-setup"
                exact
                element={
                  <SetupLayout>
                    <LayoutSetup />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/brand-logos"
                exact
                element={
                  <SetupLayout>
                    <BrandLogos />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/page-layout-management"
                exact
                element={
                  <SetupLayout>
                    <PageLayoutManagement />
                  </SetupLayout>
                }
              />
              <Route
                path="/site-setup/widgets"
                exact
                element={<WidgetSetup />}
              />
              <Route path="/api-docs" exact element={<APIDocs />} />
            </Route>
          </Routes>
        </Router>
        </PermissionProvider>
      </AppBranding>
    </Provider>
  );
}

export default App;
